import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Asset } from '../state-man/models/asset.model';

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  constructor(
    private apiService: ApiService
  ) { }
  
  // version: the one that came with the assets already held, or '' for none.
  // rows is null when those are still current.
  public async getAll (version: string) : Promise<{ version: string, rows: Asset[] | null } | null> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'assets/getForAllUnits/', { version })
      if (Array.isArray(ret)) return { version: '', rows: Asset.buildMany(ret) }
      if (ret?.unchanged) return { version: ret.version, rows: null }
      return Array.isArray(ret?.rows) ? { version: ret.version, rows: Asset.buildMany(ret.rows) } : null
    } 
    catch (error) {      
      return null
    }
  }  
}
